import { render, staticRenderFns } from "./PazientiList.vue?vue&type=template&id=41026606&"
import script from "./PazientiList.vue?vue&type=script&lang=ts&"
export * from "./PazientiList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports